import React, { useContext } from 'react';
import LeadsStatusesFetchContext from '@/modules/leads_statuses/contexts/LeadsStatusesFetchContext';
import Pagination from '@/modules/common/components/Pagination';
import { withRouter } from '~/hocs/router';
import Top from './Top';
import Table from './Table/Table';

const Data = (props) => {
    // noinspection JSCheckFunctionSignatures
    const leadsStatusesFetchContext = useContext(LeadsStatusesFetchContext);
    const data = leadsStatusesFetchContext.data;
    const setIds = leadsStatusesFetchContext.setIds;
    const setData = leadsStatusesFetchContext.setData;

    const handleClickResetFetch = () => {
        setIds('');
        setData(null);
        props.history.push({search: ''});
    };

    // noinspection JSUnresolvedVariable
    return (
        <>
            {(data && data.results)
                ? <div id="leads_statuses-fetch-fetch">
                    <Top onClickResetFetch={handleClickResetFetch}/>
                    <Table/>
                    {(data.results.length > 0)
                        ? <Pagination totalPages={data.total_pages} currentPage={data.current_page}/>
                        : null
                    }
                </div>
                : null
            }
        </>
    );
};

let Component = Data;
Component = withRouter(Component);

export default Component;
